import React from "react";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
function Pdf({ data, addSchedule, deleteSingleContent, readOnly = false }) {
  return (
    <>
      <div className="content-item content-item--pdf" key={data.key}>
        <div className="content-image">
          {!readOnly && (
            <div className="content-del-icon">
              <DeleteOutlineIcon
                onClick={() => deleteSingleContent(data.id)}
                style={{ color: "var(--primary-color)" }}
              />
            </div>
          )}
          <div className="content-placeholder content-placeholder--pdf">
            <PictureAsPdfOutlinedIcon sx={{ height: "64px", width: "64px", color: "#e53e3e" }} />
          </div>
        </div>
        <div className="content-bottom">
          <p className="content-title">{data.name?.substring(0, 24)}</p>
          <p className="content-type-pill">
            <span className="content-type-icon">
              <PictureAsPdfOutlinedIcon sx={{ fontSize: "14px", color: "var(--primary-color)" }} />
            </span>
            <span>PDF</span>
          </p>
        </div>
      </div>
    </>
  );
}

export default Pdf;
